import React, { useState, useEffect } from 'react';
import './Resume.css';
import ExecutiveSummary from './ExecutiveSummary';
import WorkingExperience from './WorkingExperience';
import AcademicHistory from './AcademicHistory';

function Resume() {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('summary');

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);

      const sections = ['summary', 'experience', 'education'];
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections[i]);
        if (el && el.getBoundingClientRect().top <= 120) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="resume">
      {/* Sticky Navigation */}
      <nav className={`nav ${scrolled ? 'scrolled' : ''}`}>
        <div className="nav-inner">
          <span className="nav-name">Ken Tsui</span>
          <div className="nav-links">
            <a href="#summary" className={activeSection === 'summary' ? 'active' : ''}>About</a>
            <a href="#experience" className={activeSection === 'experience' ? 'active' : ''}>Experience</a>
            <a href="#education" className={activeSection === 'education' ? 'active' : ''}>Education</a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <header className="hero">
        <span className="hero-label">Digital Transformation Leader</span>
        <h1>Ken Tsui</h1>
        <p className="hero-subtitle">
          20+ years driving digital transformation across retail, CRM, enterprise platforms, and GenAI — delivering measurable business outcomes.
        </p>
      </header>

      {/* Content Sections */}
      <div className="resume-content">
        <div id="summary" className="section">
          <h2 className="section-title">About</h2>
          <ExecutiveSummary />
        </div>

        <div id="experience" className="section">
          <h2 className="section-title">Experience</h2>
          <WorkingExperience />
        </div>

        <div id="education" className="section">
          <h2 className="section-title">Education</h2>
          <AcademicHistory />
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        © {new Date().getFullYear()} Ken Tsui. All rights reserved.
      </footer>
    </div>
  );
}

export default Resume;
